import React from 'react';
import StarPopover from "../../StarPopover";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check"; 
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup'; 
import SpellcheckIcon from "@material-ui/icons/Spellcheck";
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { Grid, Tooltip, withStyles, Button } from "@material-ui/core";
import styles from "../styles";  
import moment from "moment";


const FaqUtterance = props => {
    const { utterance, processed, starRating, index, value, handleRadio, classes, mapToQuestion, openModal, onStarPopoverClose } = props;
    const checked = value === "1" ? true : false;
    const date =  moment(utterance.Time).format("MMMM DD, YYYY @ hh:mm A");
    return (
        <Grid key={index} alignContent={"center"} alignItems={"center"} container spacing={2}>
            <Grid item xs={8}>
              <div className={classes.utteranceItemDiv}>
                <p className={classes.utteranceDate}><AccessTimeIcon fontSize="small"/> {date}</p>
                <p>Q: {utterance.UserInput} </p>
                {processed ? ( 
                  <React.Fragment>
                  {utterance.OriginalQuestion&&
                  <p className={classes.originalAnswer}>
                    A: <strike>{utterance.OriginalQuestion} </strike>
                  </p>
                  }
                  <p className={classes.utteranceSelectedAnswerText}>
                    A: {processed}
                  </p>
                  </React.Fragment>
                ) : (
                  
                  <p> {!utterance.AboveThreshold?<Tooltip placement="top" title="Not used on chatbot"><span className={classes.aboveTreshold}>A: </span></Tooltip> : <span>A: </span>}{utterance.OriginalQuestion ? utterance.OriginalQuestion : <React.Fragment><span className={classes.unactiveUtterance}>No answer provided</span></React.Fragment> } </p>
                )  }
              </div>
            </Grid>
            <Grid item style={{'textAlign':'center'}} xs={2}>
              <Tooltip placement="top" title="Click to edit intent">
                <span className={`${classes.intent} ${classes.faqIntent}`} onClick={ e => openModal(index, "int")}>
                {typeof utterance.Intent === "string"?utterance.Intent:utterance.Intent.name}
                </span> 
              </Tooltip>
            </Grid>
            <Grid item xs={2}>
          {processed ? (
            <React.Fragment>
              <div className={classes.actionsHolder}>
                <Tooltip placement="top" title="Select Better Answer">
                  <ToggleButton selected={true} className={classes.actionButton} variant="outlined" onClick={e => mapToQuestion(e, index)}>
                    <SpellcheckIcon/>
                  </ToggleButton>
                </Tooltip>
                <StarPopover index={index} stars={starRating} onClose={onStarPopoverClose} />
              </div>
            </React.Fragment>
          ) : (
            <div className={classes.actionsHolder}>
              <Tooltip placement="top" title="Select Better Answer">
                <Button className={classes.actionButton} variant="outlined" onClick={e => mapToQuestion(e, index)}>
                  <SpellcheckIcon />
                </Button>
              </Tooltip>
              <StarPopover index={index} stars={starRating} onClose={onStarPopoverClose} />
              <ToggleButtonGroup
                 value={value}
                 exclusive
                 onChange={(e, val) => handleRadio(val, index)} 
                 size="small"
                 className={classes.formGroup}>
                <Tooltip placement="top" title="Mark Incorrect">
                  <ToggleButton className={classes.formGroupButtonRed} selected={value === "0"} value="0" aria-label="no"> 
                     <CloseIcon /> 
                  </ToggleButton>
                </Tooltip>
                <Tooltip placement="top" title="Mark Correct">
                  <ToggleButton className={classes.formGroupButtonGreen} selected={value === "1"} value="1" aria-label="yes">
                     <CheckIcon />
                  </ToggleButton>
                </Tooltip>
              </ToggleButtonGroup>
            </div>
          )}
          </Grid>
        </Grid>
    );
  }

  export default withStyles(styles)(React.memo(FaqUtterance, uttersEqual));

  function uttersEqual(prevProps, nextProps){ 
    if(prevProps.processed !== nextProps.processed ||
       prevProps.starRating !== nextProps.starRating ||
       prevProps.value !== nextProps.value ){
      return false;
    }else{
      return true;
    }
  }